export const compareValues = (a: any, b: any, dir: any): number => {
  if (a === b) return 0;
  if (dir === 'asc') return a > b ? 1 : -1;
  return a < b ? 1 : -1;
};